/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Choose_VisibilityInputs */

const en_dialog_choose_visibility = /** @type {(inputs: Dialog_Choose_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose who can see your upload`)
};

const es_dialog_choose_visibility = /** @type {(inputs: Dialog_Choose_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige quién puede ver tu subida`)
};

/**
* | output |
* | --- |
* | "Choose who can see your upload" |
*
* @param {Dialog_Choose_VisibilityInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_choose_visibility = /** @type {((inputs?: Dialog_Choose_VisibilityInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Choose_VisibilityInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_choose_visibility(inputs)
	return en_dialog_choose_visibility(inputs)
});